import { useState, useRef, useEffect } from "react";
import { sendRequest } from '../../hooks/requests/useRequest';
import debounce from "lodash.debounce";

export const useSearchQuoter = (chekTypeClient) => {
console.log("🌈 chekTypeClient", chekTypeClient);

    const [value, setValue] = useState("");
    const [resultsSearch, setResultsSearch] = useState([]);
    const [loading, setLoading] = useState(false);
    const [overlayPanel, setOverlayPanel] = useState(null);
    const [pendingSelection, setPendingSelection] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);

    const autoCompleteRef = useRef(null);
    const lastQueryRef = useRef("");
    const [selectedAgreement, setSelectedAgreement] = useState(null);
    const selectedAgreementRef = useRef(null);
    const chekTypeClientRef = useRef(chekTypeClient);
    useEffect(() => {
        chekTypeClientRef.current = chekTypeClient;
    }, [chekTypeClient]);

    const [counts, setCounts] = useState({
        agreements: 0,
        exams: 0,
        profiles: 0
    });
    useEffect(() => {
        selectedAgreementRef.current = selectedAgreement;
    }, [selectedAgreement]);


    const debouncedSearchQuoter = useRef(

        debounce(async (query) => {

            lastQueryRef.current = query;

            if (!query || query.length < 3) {

                setLoading(false);

                setResultsSearch([
                    {
                        isMessage: true,
                        message: "Escribe al menos 3 caracteres para buscar"
                    }
                ]);

                setCounts({
                    agreements: 0,
                    exams: 0,
                    profiles: 0
                });

                return;
            }

            setLoading(true);

            try {

                const response = await sendRequest(
                    { method: 'GET' },
                    // `SearchQuoter/SearchQuoter?search=${query}`
                    `SearchQuoter/SearchQuoter?search=${encodeURIComponent(query)}&isWorkOrder=true`

                );

                if (lastQueryRef.current !== query) return;

                const data = response?.data || {};

                const agreements = data?.agreements || [];
                const estudios = data?.estudios || [];

                // BUSCAR POR CLAVE DEL ESTUDIO
                const searchText = query.trim().toUpperCase();

                const isStudyCodeSearch = estudios.some(item => {

                    const clean = item.component
                        .replace("[EXAMEN]", "")
                        .replace("[PERFIL]", "")
                        .trim();

                    const abbreviation =
                        clean.split(" - ")[0]?.toUpperCase();

                    return abbreviation?.trim() === searchText;
                });

                const agreementsFiltered =
                    isStudyCodeSearch
                        ? []
                        : agreements;

                const exams = estudios.filter(
                    x => !x.component.includes("[PERFIL]")
                );

                const profiles = estudios.filter(
                    x => x.component.includes("[PERFIL]")
                );

                const isAllEmpty =
                    agreementsFiltered.length === 0 &&
                    exams.length === 0 &&
                    profiles.length === 0;

                if (isAllEmpty) {

                    setResultsSearch([
                        {
                            isMessage: true,
                            message: `No hay resultados para "${query}"`
                        }
                    ]);

                    setCounts({
                        agreements: 0,
                        exams: 0,
                        profiles: 0
                    });

                    setLoading(false);

                    return;
                }

                setCounts({
                    agreements: agreementsFiltered.length,
                    exams: exams.length,
                    profiles: profiles.length
                });

                let flat = [];

                const agreementSelected =
                    selectedAgreementRef.current;

                const currentType = chekTypeClientRef.current;

                const isParticular =
                    currentType === 1;

                const isCompanyMode =
                    currentType !== 1;
                    
                console.log({
                    currentType,
                    isParticular,
                    estudios: estudios.length,
                    agreements: agreements.length
                });
                /*
                |--------------------------------------------------------------------------
                | PARTICULAR
                |--------------------------------------------------------------------------
                |
                | Siempre mostrar estudios
                |
                */

                if (isParticular) {

                    if (estudios.length > 0) {

                        flat.push({
                            isGroup: true,
                            group_name: "Estudios"
                        });

                        estudios.forEach(item => {

                            const isProfile =
                                item.component.includes("[PERFIL]");

                            flat.push({
                                ...item,
                                type: isProfile
                                    ? "profile"
                                    : "exam",
                                isGroup: false
                            });

                        });

                    }

                }

                /*
                |--------------------------------------------------------------------------
                | EMPRESA - SIN CONVENIO
                |--------------------------------------------------------------------------
                |
                | Buscar únicamente convenios
                |
                */

                if (
                    isCompanyMode &&
                    !agreementSelected
                ) {

                    if (agreementsFiltered.length > 0) {

                        flat.push({
                            isGroup: true,
                            group_name: "Convenios"
                        });

                        agreementsFiltered.forEach(item => {

                            flat.push({
                                ...item,
                                type: "agreement",
                                isGroup: false
                            });

                        });

                    }

                }

                /*
                |--------------------------------------------------------------------------
                | EMPRESA - CON CONVENIO SELECCIONADO
                |--------------------------------------------------------------------------
                |
                | Estudios primero
                | Convenios después
                |
                */

                if (
                    isCompanyMode &&
                    agreementSelected
                ) {

                    /*
                    |--------------------------------------------------------------------------
                    | ESTUDIOS
                    |--------------------------------------------------------------------------
                    */

                    if (estudios.length > 0) {

                        flat.push({
                            isGroup: true,
                            group_name: "Estudios"
                        });

                        estudios.forEach(item => {

                            const isProfile =
                                item.component.includes("[PERFIL]");

                            flat.push({
                                ...item,
                                type: isProfile
                                    ? "profile"
                                    : "exam",
                                isGroup: false
                            });

                        });

                    }

                    /*
                    |--------------------------------------------------------------------------
                    | CONVENIOS
                    |--------------------------------------------------------------------------
                    */

                    if (agreementsFiltered.length > 0) {

                        flat.push({
                            isGroup: true,
                            group_name: "Convenios"
                        });

                        agreementsFiltered.forEach(item => {

                            flat.push({
                                ...item,
                                type: "agreement",
                                isGroup: false
                            });

                        });

                    }

                }

                setResultsSearch(flat);

                setLoading(false);

            } catch (error) {

                if (lastQueryRef.current !== query) return;

                console.error(error);

                setResultsSearch([
                    {
                        isMessage: true,
                        message: "Error al buscar, intenta nuevamente"
                    }
                ]);

                setCounts({
                    agreements: 0,
                    exams: 0,
                    profiles: 0
                });

                setLoading(false);
            }

        }, 300)

    ).current;

    const searchGlobal = (e) => {

        const query = e?.query ?? value;

        debouncedSearchQuoter(query);
    };

    useEffect(() => {

        return () => {
            debouncedSearchQuoter.cancel();
        };

    }, [debouncedSearchQuoter]);

    const parseAgreement = (agreement) => {

        return {
            id_agreement: agreement.id_agreement,
            id_company: agreement.id_company,
            contract_number: agreement.contract_number,
            company: agreement.name_company,
            code_company: agreement.code_company,
            sales_name: agreement.sales_name
        };
    };

    const parseExamProfile = (text) => {

        const isProfile =
            text.includes("[PERFIL]");

        const clean = text
            .replace("[PERFIL]", "")
            .replace("[EXAMEN]", "")
            .trim();

        const parts = clean.split(" - ");

        return {
            type: isProfile ? "PERFIL" : "EXAMEN",
            abbreviation: parts[0] || "",
            name: parts.slice(1).join(" - ") || ""
        };
    };

    const syncOverlayPanel = () => {

        const overlay =
            autoCompleteRef.current?.getOverlay?.() || null;

        setOverlayPanel(overlay);
    };

    useEffect(() => {

        if (showConfirm && autoCompleteRef.current) {

            setTimeout(() => {
                autoCompleteRef.current.show();
            }, 0);

        }

    }, [showConfirm]);

    const resetSearch = () => {

        setValue("");
        setResultsSearch([]);
        setPendingSelection(null);
        setShowConfirm(false);
        setOverlayPanel(null);
        setSelectedAgreement(null);

        lastQueryRef.current = "";

        debouncedSearchQuoter.cancel();

        if (
            autoCompleteRef.current &&
            autoCompleteRef.current.hide
        ) {
            autoCompleteRef.current.hide();
        }

    };

    return {
        value,
        setValue,
        resultsSearch,
        setResultsSearch,
        searchGlobal,
        counts,
        loading,
        selectedAgreement,
        setSelectedAgreement,
        pendingSelection,
        setPendingSelection,
        showConfirm,
        setShowConfirm,
        parseAgreement,
        parseExamProfile,
        autoCompleteRef,
        syncOverlayPanel,
        overlayPanel,
        setOverlayPanel,
        resetSearch

    };
};